import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common/loaders/SkeletonBlock';

const ResourceDatabaseItemsCardSkeleton = (): React.ReactElement => (
  <SkeletonContainer>
    <SkeletonHeader />
    {[...Array(5)].map((_, idx) => (
      <SkeletonItem key={idx} />
    ))}
  </SkeletonContainer>
);

export { ResourceDatabaseItemsCardSkeleton };

const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
`;

const SkeletonHeader = styled(SkeletonBlock)`
  height: 36px;
`;

const SkeletonItem = styled(SkeletonBlock)`
  height: 40px;
  margin: 12px 0;
`;
